export const DocumentsInfo = () => (
  <>
    <p>
      For some type of documents such as LOI and Porting forms, multiple
      versions can be active on the same profile.
    </p>
    <p>
      For the other type documents the latest validated version is the active
      one.
    </p>
  </>
);
